import { Grid } from "@mui/material";
import { Divider } from "antd";

export const DividerComponent = ({
  label,
  children,
}: {
  label: string;
  children?: any;
}) => {
  return (
    <Grid item xs={12}>
      <Divider
        dashed
        orientation="left"
        style={{
          borderColor: "#006400",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection:"row",
          flexWrap: "nowrap",
        }}
      >
        <p style={{ color: "green", fontSize: "12px", fontWeight: "bolder" }}>
          {label }&nbsp;&nbsp;&nbsp;&nbsp;
          {children}
        </p>
      </Divider>
    </Grid>
  );
};
